import styled from 'vue3-styled-components'

const CommonLayout = styled.div``

export default CommonLayout
